import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatCardModule } from '@angular/material/card'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSelectModule } from '@angular/material/select'
import { MatSortModule } from '@angular/material/sort'
import { MatTableModule } from '@angular/material/table'
import { BrowserModule } from '@angular/platform-browser'
import { RouterModule } from '@angular/router'
import { TablerIconsModule } from 'angular-tabler-icons'
import { IconSearch } from 'angular-tabler-icons/icons'
import { ReporteCostosComponent } from 'src/app/reportes/reporte-costos/reporte-costos.component'
import { ReporteStockComponent } from 'src/app/reportes/reporte-stock/reporte-stock.component'
import { ReportesRoutingModule } from 'src/app/reportes/reportes-routing.module'
import { ReportesComponent } from 'src/app/reportes/reportes.component'

@NgModule({
  declarations: [
    ReportesComponent,
    ReporteStockComponent,
    ReporteCostosComponent
  ],
  imports: [
    MatSortModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    RouterModule,
    MatCardModule,
    MatTableModule,
    MatInputModule,
    MatSelectModule,
    TablerIconsModule.pick({ IconSearch }),
    MatFormFieldModule,
    MatPaginatorModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    ReportesRoutingModule,
    MatProgressSpinnerModule
  ]
})
export class ReportesModule {}
